import React, { Component } from 'react';
import { Alert, Spinner, Modal, ModalBody, FormFeedback, Card, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Row, Col, Input, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import _ from 'underscore';
import { withRouter } from 'react-router';
import serialize from 'form-serialize';
import API from '~/API';
import { Link } from 'react-router-dom';
import { Global } from '~/App';
import Turnstile from '~/components/Turnstile';

class Registro extends Component {
    static displayName = Registro.name;

    constructor(props) {
        super(props);
        this.captchaRef = React.createRef();
        this.pendingForm = null;
        this.onCaptchaResolved = this.onCaptchaResolved.bind(this);
        this.onCaptchaError = this.onCaptchaError.bind(this);
        this.state = {
            errores: [],
            cargando: false,
            password: "",
            password2: "",
            nombre: null,
            apellido: null,
            correo: "",
            correoValido: false,
            rut: null,
            telefono: null,
            politicaAceptada: Global.Politicas ? false : true,
            abrirPoliticas: false,
            success: null // Para manejar el estado de éxito
        };
    }
    validarDatos(form) {
        var errores = [];
        if (!form.Mail) {
            errores.push("Debes indicar Correo");
        }
        if (!form.Password) {
            errores.push("Debes indicar Contraseña");
        } else {
            const validacionPass = Global.validarPoliticaPassword ? Global.validarPoliticaPassword(form.Password) : { esValida: form.Password.length >= 10, errores: [`La contraseña debe tener al menos 10 caracteres`] };
            if (!validacionPass.esValida) {
                errores.push(...validacionPass.errores);
            }
        }
        if (!form.ConfirmPassword) {
            errores.push("Debes confirmar tu Contraseña");
        }
        if (!form.Nombre) {
            errores.push("Debes indicar tu Nombre");
        }
        if (!form.Apellido) {
            errores.push("Debes indicar tu Apellido");
        }
        if (!form.Telefono) {
            errores.push("Debes indicar tu Teléfono");
        }
        if (!form.Rut) {
            errores.push("Debes indicar tu Rut");
        }
        if (form.Password !== form.ConfirmPassword) {
            errores.push("Las Contraseñas tienen que coincidir")
        }
        if(!Global.ValidaRUT(this.state.rut)){
            errores.push("El RUT ingresado no es válido");
        }
        this.setState({ errores });
        return _.isEmpty(errores);
    }
    Registrar(event) {
        event.preventDefault();
        var form = serialize(event.target, { hash: true });
        if (this.validarDatos(form)) {
            this.setState({ cargando: true, errores: [] });
            this.pendingForm = form;
            // Si el sitio tiene Turnstile configurado, lo ejecutamos; si no, enviamos directo
            if (Global.apiKeyCaptcha && this.captchaRef.current) {
                this.captchaRef.current.execute();
            } else {
                this.onCaptchaResolved("");
            }
        }
    }
    onCaptchaError() {
        this.pendingForm = null;
        this.setState({ cargando: false });
    }
    onCaptchaResolved(token) {
        const form = this.pendingForm;
        this.pendingForm = null;
        if (!form) return;
        if (token) {
            form.Captcha = token;
        }
        form.Empresa = Global.nombre;
        API.Call("Home/Register", form)
            .then(response => {
                this.setState({ success: response.mensaje, cargando: false });
            })
            .catch(error => {
                if (this.captchaRef.current) this.captchaRef.current.reset();
                this.setState({ cargando: false, errores: [error] });
            });
    }
    render() {
        const validacionPassword = Global.validarPoliticaPassword ? Global.validarPoliticaPassword(this.state.password) : { esValida: this.state.password.length >= 10, mensajePrincipal: "La contraseña debe tener al menos 10 caracteres" };
        if (this.state.cargando) {
            return (
                <div className="text-center p-5">
                    <Spinner style={{ width: '3rem', height: '3rem' }} />
                    <h4>Creando tu cuenta...</h4>
                </div>
            );
        }

        if (this.state.success) {
            return (
                 <Row className="registro-wrapper">
                    <Col sm="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
                        <Card className="text-center registro-success-card">
                            <CardBody>
                                <div className="success-icon">✓</div>
                                <h4 className="card-title">¡Registro Exitoso!</h4>
                                <p className="card-text text-muted">{this.state.success}</p>
                                <Button color="primary" size="lg" tag={Link} to="/administra" className="mt-3">
                                    Ir a Iniciar Sesión
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            );
        }

        return (
            <Row className="registro-wrapper">
                <Col sm="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
                    <Card className="registro-card">
                        <CardHeader className="registro-header">
                            <h4>Crear una Cuenta</h4>
                            <p className="text-muted">Únete para gestionar tus servicios de forma fácil y rápida.</p>
                        </CardHeader>
                        <CardBody>
                             <Form onSubmit={this.Registrar.bind(this)}>
                                {this.state.errores.length > 0 && 
                                    <Alert color="warning">
                                        <h6 className="alert-heading">Por favor, corrige los siguientes errores:</h6>
                                        <ul className="mb-0">
                                            {this.state.errores.map((e, i) => <li key={i}>{e}</li>)}
                                        </ul>
                                    </Alert>
                                }
                                
                                <h6 className="form-section-title">Información de la Cuenta</h6>
                                <FormGroup>
                                    <Label for="Mail">Correo Electrónico</Label>
                                     <InputGroup>
                                        <InputGroupAddon addonType="prepend"><InputGroupText>📧</InputGroupText></InputGroupAddon>
                                        <Input invalid={this.state.correo.length > 0 && !this.state.correoValido} type="email" name="Mail" id="Mail" placeholder="tu.correo@ejemplo.com" onChange={e => this.setState({ correo: e.target.value, correoValido: Global.ValidateEmail(e.target.value) })} />
                                        <FormFeedback>Debe ser un correo válido</FormFeedback>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Password">Contraseña</Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend"><InputGroupText>🔒</InputGroupText></InputGroupAddon>
                                        <Input invalid={this.state.password.length > 0 && !validacionPassword.esValida} type="password" name="Password" id="Password" placeholder="Crea una contraseña segura" value={this.state.password} onChange={e => this.setState({ password: e.target.value })}/>
                                        <FormFeedback>{validacionPassword.mensajePrincipal}</FormFeedback>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="ConfirmPassword">Confirmar Contraseña</Label>
                                    <InputGroup>
                                         <InputGroupAddon addonType="prepend"><InputGroupText>🔒</InputGroupText></InputGroupAddon>
                                        <Input invalid={this.state.password2.length > 0 && this.state.password !== this.state.password2} type="password" name="ConfirmPassword" id="ConfirmPassword" placeholder="Vuelve a escribir la contraseña" value={this.state.password2} onChange={e => this.setState({ password2: e.target.value })}/>
                                        <FormFeedback>Las contraseñas deben coincidir</FormFeedback>
                                    </InputGroup>
                                </FormGroup>
                                
                                <h6 className="form-section-title">Información Personal</h6>
                                <Row form>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="Nombre">Nombre</Label>
                                            <Input invalid={this.state.nombre !== null && !this.state.nombre} type="text" name="Nombre" id="Nombre" onChange={e => this.setState({ nombre: e.target.value })} />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="Apellido">Apellido</Label>
                                            <Input invalid={this.state.apellido !== null && !this.state.apellido} type="text" name="Apellido" id="Apellido" onChange={e => this.setState({ apellido: e.target.value })} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                 <FormGroup>
                                    <Label for="Rut">RUT</Label>
                                    <Input invalid={this.state.rut !== null && !Global.ValidaRUT(this.state.rut)} type="text" name="Rut" id="Rut" placeholder="12.345.678-9" onChange={e => this.setState({ rut: e.target.value })}/>
                                    <FormFeedback>Debe ser un RUT válido (con puntos y guión)</FormFeedback>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Telefono">Teléfono</Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend"><InputGroupText>📱</InputGroupText></InputGroupAddon>
                                        <Input invalid={this.state.telefono !== null && (this.state.telefono || "").length < 9} type="tel" name="Telefono" id="Telefono" placeholder="9 1234 5678" onChange={e => this.setState({ telefono: e.target.value })}/>
                                         <FormFeedback>Debe tener al menos 9 caracteres</FormFeedback>
                                    </InputGroup>
                                </FormGroup>

                                {Global.politicas && <FormGroup check className="my-4 text-center">
                                    <Input type="checkbox" id="politica-check" checked={this.state.politicaAceptada} onChange={() => this.setState({ politicaAceptada: !this.state.politicaAceptada })} />
                                    <Label for="politica-check" check>
                                        Acepto los <a href="#" onClick={e => { e.preventDefault(); this.setState({ abrirPoliticas: !this.state.abrirPoliticas }) }}>Términos y Condiciones</a>.
                                    </Label>
                                </FormGroup>}
                                
                                <Turnstile
                                    ref={this.captchaRef}
                                    size="invisible"
                                    sitekey={Global.apiKeyCaptcha}
                                    onChange={this.onCaptchaResolved}
                                    onErrored={this.onCaptchaError}
                                    onExpired={this.onCaptchaError}
                                />
                                <Button block size="lg" disabled={!Global.ValidaRUT(this.state.rut) || (this.state.telefono || "").length < 9 || !validacionPassword.esValida || this.state.password !== this.state.password2 || !this.state.nombre || !this.state.apellido || !this.state.correoValido || !this.state.politicaAceptada} color="primary" type="submit">Crear Cuenta</Button>
                             </Form>
                        </CardBody>
                         <CardFooter className="registro-footer">
                           <span>¿Ya tienes una cuenta?</span>
                           <Link to={"/administra"} className="font-weight-bold">Inicia Sesión</Link>
                        </CardFooter>
                    </Card>
                </Col>
                {Global.politicas && 
                    <Modal size="lg" className="TerminosCondiciones" wrapClassName="asyntec-portal-clientes" isOpen={this.state.abrirPoliticas} toggle={() => this.setState({ abrirPoliticas: !this.state.abrirPoliticas })} scrollable>
                        <ModalBody >
                            <div dangerouslySetInnerHTML={{ __html: Global.politicas }} />
                            <Button color="primary" className="mt-3 float-right" onClick={() => this.setState({ abrirPoliticas: false })}>Cerrar</Button>
                        </ModalBody>
                    </Modal>
                }
            </Row>
        );
    }
}

export default withRouter(Registro);